import { BasePresenter } from "../base/base.presenter";
import { IProaSummary } from "@interfaces/screens/proa-summary.interface";
import {
  Utilities,
  String,
  Enums,
  queryString,
  Dictionary,
  Constants,
} from "@utils";
import {
  IAEAColumnDefinition,
  ICmdBasicDataProjectProa,
  ICmdBasicDataProjectProaRRHH,
  IBudgetFormBasicDataMasters,
  ILang,
  IProaDetailImpl,
  ISelectItem,
} from "@models/*";
import { useSelector } from "react-redux";
import {
  IProaService,
  ProaService,
} from "@services/proyecta/proa-form.service";
import DataGrid from "devextreme/ui/data_grid";

export class ProaSummaryPresenter extends BasePresenter<IProaSummary> {
  public currentLabels: Dictionary<string, string>;
  public currentDatosBasicosSelect: any;
  public currentLang: ILang;
  public summaryData: any;
  public projectsGrouped: any;
  public view: IProaSummary;
  public formMasters: IBudgetFormBasicDataMasters;
  public params: any;

  private _service: IProaService;
  private _viewMode: boolean = false;

  constructor(view: IProaSummary) {
    super(view);
    this._service = new ProaService();
    this.initialize();
    this._viewMode = window.location.href.includes("view");
    this.view = view;
    
  }

  //#region Public Methods
  public initialize() {
    this.summaryData = useSelector(this.context.proaStore.selectAllSummaryData);
    this.currentLang = useSelector(this.context.sessionStore.selectLang);
    this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
    this.projectsGrouped = useSelector(this.context.proaStore.selectProjectsGrouped)
    this.formMasters = useSelector(this.context.proaStore.selectFormMasters);
    this.params = useSelector(this.context.sessionStore.selectParams);


  }

  public initRender(): boolean {
    return (
      !Utilities.isNullObject(this.view.state.basicDataColumnDefinition) &&
      !Utilities.isNullObject(this.view.state.currentApplicationMasters)
    );
  }

  public onInitialize(reset?: boolean) {
    if (reset){
      this.dispatcherProgress(70);
      this.dispatcherPendingLoad(1);
    }
    const query = queryString.parseUrl(window.location.href.replace("#", ""))
      .query as any;
    if (!Utilities.isNullObject(query) && !Utilities.isNullObject(query.Id)) {
      Promise.all([
        this._service.getProa(query.Id),
        this._service.getLocations(query.Id),
        this._service.getFFRRBeneficAnio(query.Id),
        this._service.getSocialPartners(query.Id),
        this._service.getProaSubproyectoFRStep1(query.Id),
        this._service.getBeneficiariesDuplicates(query.Id)
      ])
        .then((allDataResponse: any) => {
          this.view.state.setCurrentProaFormValues(allDataResponse[0]);
          this.view.state.setSection4Locations(allDataResponse[1]);
          this.view.state.setBasicdataFFRR(allDataResponse[2]);
          this.view.state.setLocalPertners(allDataResponse[3] ?? []);
          this.view.state.setProaSubproyect(allDataResponse[4]);
          this.view.state.setBeneficiariesDuplicates(allDataResponse[5] ?? []);
          if (reset){
            this.dispatcherProgress(90);
            this.dispatcherUnsetSetLoading();
          }
        })
        .catch((error: Error) => {
          if (reset){
            this.dispatcherProgress(90);
            this.dispatcherUnsetSetLoading();
          }
          this.writeErrorLog(error).then(() => {});
        });
    } else {
      if (reset){
        this.dispatcherProgress(90);
        this.dispatcherUnsetSetLoading();
      }
    }
  }

  public getTotalHyMDataFFRR() {
    let totalHombres =
      this.view.state.basicdataFFRR?.reduce(
        (accum: any, item: any) => accum + item.PFFRRTotalHombres,
        0
      ) || null;
    let totalMujeres =
      this.view.state.basicdataFFRR?.reduce(
        (accum: any, item: any) => accum + item.PFRRTotalMujeres,
        0
      ) || null;
    return { totalHombres, totalMujeres };
  }

  public async savePlanning(proaEntity: ICmdBasicDataProjectProa) {
    let planning = proaEntity.PlanificacionAprobada
    let projectCode = this.view.state.currentProaFormValues?.currentBudget?.PPresCodProy || null
    let auxRes = Utilities.copyObject(this.summaryData)
    let projectResum = auxRes.filter((a: any) => {
      if(a.PProaCodProyecto === projectCode){
        a.PProaEstado = planning ? 'Aprobada' : 'En Proceso' || 'En Proceso';
        switch (a.PProaIdioma) {
          case "EN": a.PProaEstado = planning ? 'Approved' : 'In process' || 'In process'; break;
          case "PT": a.PProaEstado = planning ? 'Aprovado' : 'Em processo' || 'Em processo'; break;
          case "FR": a.PProaEstado = planning ? 'approuvé' : 'en procès' || 'en procès'; break;
        }

        return a;
      }
    })

    if(!!projectResum.length) await this._service.savePlanning(projectResum)
    return
  }

  public async save() {
    const proaEntity = this.mappCurrentProaToProaEntity();
    const rrhhEntity = this.mappCurrentProaRrhhToProaEntity();
    const stepsEntity = this.mappCurrentProaStepsToEntity();
    const tableConfig = this.getDataSourceFromTable("data-config-codes");
    const itemsConfig = this.projectsGrouped;
    const dupBeneficiaries = this.view.state.beneficiariesDuplicates;
    const currentUser = this.currentUser.currentUser.userPrincipalName;

    try {
      this.dispatcherProgress(0);
      this.dispatcherPendingLoad(1);
      this.dispatcherSetLoading();
      this.dispatcherProgress(30);
      let item = null;
      await this.savePlanning(proaEntity)
      if (Utilities.isNullObject(proaEntity.Id)) {
        this.dispatcherProgress(50);
        item = await this._service.saveProa(
          proaEntity,
          stepsEntity,
          rrhhEntity,
          tableConfig,
          itemsConfig,
          dupBeneficiaries,
          currentUser
        );
        this.dispatcherPendingLoad(1);
      } else {
        this.dispatcherProgress(50);
        item = await this._service.updateProa(
          proaEntity,
          stepsEntity,
          rrhhEntity,
          tableConfig,
          itemsConfig,
          dupBeneficiaries,
          currentUser
        );
        this.dispatcherPendingLoad(1);
      }
      const title = this.currentLabels.get("ProaFormGeneralSummary");
      const msg = this.currentLabels.get("SaveSucess");
      this.dispatcherPendingLoad(1);
      Utilities.notifySuccess(msg, title).then((x) => {
        this.onInitialize(true);
        if(!!proaEntity.PlanificacionAprobada) this.context.history.push(`/proyecta/proa/view?Id=${proaEntity.PPresPresupuestoId}`);
        else this.context.history.push(`/proyecta/proa/edit?Id=${proaEntity.PPresPresupuestoId}`);
        setTimeout(() => this.context.history.go(0), 500)
      });
    } catch (error) {
      this.writeErrorLog(error as Error).then(() => {
        Utilities.notifySuccess(
          this.currentLabels.get("SaveFail"),
          this.currentLabels.get("ProaFormGeneralSummary")
        );
      });
    }
  }
  //#endregion

  //#region Private Methods
  private getDataSourceFromTable(tableId: string): Array<any> {
    let element = document.getElementById(tableId);
    if (Utilities.isNullEmptyObject(element)) {
      return [];
    }

    let instance = DataGrid.getInstance(element) as DataGrid;
      return instance.getDataSource().items();
  }

  private getValue(field: any) {
    let value: any = undefined;
    let shouldReplaceHtmlTags: boolean = false;

    switch (field) {
      case Enums.ProaBasicFields.PrCode:
        value =
          this.view.state.currentProaFormValues?.currentBudget?.PPresCodProy ??
          null;
        break;
      case Enums.ProaBasicFields.Country:
        {
          value = "";
          if (
            this.view.state.currentProaFormValues?.currentBudget.isRegion ===
            true
          ) {
            value =
              this.view.state?.currentApplicationMasters?.regions?.find(
                (x: any) =>
                  x.Id ===
                  parseInt(
                    this.view.state.currentProaFormValues?.currentBudget?.RegionCountry[0].id.replace(
                      "rg_",
                      ""
                    )
                  )
              )?.Title ?? "";
          }
          if (
            this.view.state.currentProaFormValues?.currentBudget.isRegion ===
            false
          ) {
            value =
              this.view.state?.currentApplicationMasters?.countries?.find(
                (x: any) =>
                  x.Id ===
                  this.view.state.currentProaFormValues?.currentBudget
                    ?.Country[0].id
              )?.Title ?? "";
          }
        }
        break;
      case Enums.ProaBasicFields.NombreProyecto:
        value =
          this.view.state.currentProaFormValues?.currentBudget?.Title ?? null;
        break;
      case Enums.ProaBasicFields.Region:
        {
          value = "";
          if (
            this.view.state.currentProaFormValues?.currentBudget?.isRegion ===
            true
          ) {
            value =
              this.view.state?.currentApplicationMasters?.regions?.find(
                (x: any) =>
                  x.Id ===
                  parseInt(
                    this.view.state.currentProaFormValues?.currentBudget?.RegionCountry[0].id.replace(
                      "rg_",
                      ""
                    )
                  )
              )?.Title ?? "";
          }
          if (
            this.view.state.currentProaFormValues?.currentBudget?.isRegion ===
            false
          ) {
            let country = this.view.state?.currentApplicationMasters?.countries?.find(
              (x: any) =>
                x.Id ===
                this.view.state.currentProaFormValues?.currentBudget?.Country[0]
                  .id
            );
            if (country) {
              value =
                this.view.state?.currentApplicationMasters?.regions?.find(
                  (x: any) => x.Id === country.OCTAVIARegionId
                )?.Title ?? "";
            }
          }
        }
        break;
      case Enums.ProaBasicFields.LineaEstrategica:
        {
          if (
            this.view.state.currentProaFormValues?.currentBudget
              ?.LineaIntervencionId?.length > 0
          ) {
            value =
              this.view.state?.currentApplicationMasters?.interventionLines?.find(
                (x: any) =>
                  x.Id ===
                  this.view.state.currentProaFormValues?.currentBudget
                    ?.LineaIntervencionId[0].id
              )?.Title ?? "";
          } else {
            value = String.Empty;
          }
        }
        break;
      case Enums.ProaBasicFields.IndicadorLineaEstrategica:
        value =
          this.view.state?.currentApplicationMasters?.strategicLines?.find(
            (x: any) =>
              x.ID ===
              this.view.state.currentProaFormValues?.currentBudget
                ?.tituloLineaEstrategica
          )?.Title ?? "";
        break;
      case Enums.ProaBasicFields.Planificacion:
        value =
          this.view.state.currentProaFormValues?.datosBasicos
            ?.PlanificacionAprobada ?? false;
        break;
      case Enums.ProaBasicFields.FechaFin:
        value = this.formatDate(
          this.view.state.currentProaFormValues?.datosBasicos
            ?.OCTAVIAFechaFinalizacion
        );
        this.view.state.setEndDate(
          this.view.state.currentProaFormValues?.datosBasicos
            ?.OCTAVIAFechaFinalizacion
        );
        break;
      case Enums.ProaBasicFields.FechaInicio:
        value = this.formatDate(
          this.view.state.currentProaFormValues?.datosBasicos
            ?.OCTAVIAFechaInicio
        );
        this.view.state.setBeginDate(
          this.view.state.currentProaFormValues?.datosBasicos
            ?.OCTAVIAFechaInicio
        );
        break;
      case Enums.ProaBasicFields.Etiquetas:
        {
          value = [];
          if (
            Array.isArray(
              this.view.state.currentProaFormValues?.datosBasicos
                ?.OCTAVIAEtiquetasId
            )
          ) {
            value = this.view.state.currentProaFormValues.datosBasicos
              .OCTAVIAEtiquetasId;
          }
        }
        break;
      case "PPresPresupuesto":
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PPresPresupuesto;
        shouldReplaceHtmlTags = true;
        break;
      case Enums.ProaBasicFields.AEAParticipatesInEjecution:
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PRGParticipacion;
        break;
      case Enums.ProaBasicFields.AEARol:
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PRGRolAeA;
        shouldReplaceHtmlTags = true;
        break;
      case Enums.ProaBasicFields.ImplementersRol:
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PRGRolImplementadores;
        shouldReplaceHtmlTags = true;
        break;
      case Enums.ProaBasicFields.ProjectSummary:
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PRGResumenProyecto;
        shouldReplaceHtmlTags = true;
        break;
      case Enums.ProaBasicFields.Methodology:
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PRGMetodologia;
        shouldReplaceHtmlTags = true;
        break;
      case Enums.ProaBasicFields.CompletarLocaciones:
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PRGLocalizacion;
        shouldReplaceHtmlTags = true;
        break;
      case Enums.ProaBasicFields.ProblemsAndJustification:
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PRGProblematica;
        shouldReplaceHtmlTags = true;
        break;
      case Enums.ProaBasicFields.BeneficiaryDescription:
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PRGDescripcionBeneficiarios;
        shouldReplaceHtmlTags = true;
        break;
      case Enums.ProaBasicFields.BeneficiaryCollective:
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PFRRBeneficiariosId;
        break;
      case Enums.ProaBasicFields.DedicacionAdministrador:
        value =
          this.view.state.currentProaFormValues?.proaRRHH
            ?.PRGDedicacionAdministrador ?? 0;
        break;
      case Enums.ProaBasicFields.DedicacionGerente:
        value =
          this.view.state.currentProaFormValues?.proaRRHH
            ?.PRGDedicacionGerente ?? 0;
        break;
      case Enums.ProaBasicFields.IdentificacionAdministrador:
        value =
          this.view.state.currentProaFormValues?.proaRRHH
            ?.PRGIdentificacionAdministrador0 ?? "";
        break;
      case Enums.ProaBasicFields.IdentificacionGerente:
        value =
          this.view.state.currentProaFormValues?.proaRRHH
            ?.PRGIdentificacionGerente0 ?? "";
        break;
      case Enums.ProaBasicFields.TipoAdministrador:
        {
          if (
            this.view.state.currentProaFormValues?.proaRRHH
              ?.PRGTipoAdministradorId
          ) {
            value = Array.isArray(
              this.view.state.currentProaFormValues.proaRRHH
                .PRGTipoAdministradorId
            )
              ? this.view.state.currentProaFormValues.proaRRHH
                  .PRGTipoAdministradorId
              : [
                  this.view.state.currentProaFormValues.proaRRHH
                    .PRGTipoAdministradorId,
                ];
          }
        }
        break;
      case Enums.ProaBasicFields.TipoGerenteProyecto:
        {
          if (
            this.view.state.currentProaFormValues?.proaRRHH
              ?.PRGTipoGerenteProyectoId
          ) {
            value = Array.isArray(
              this.view.state.currentProaFormValues.proaRRHH
                .PRGTipoGerenteProyectoId
            )
              ? this.view.state.currentProaFormValues.proaRRHH
                  .PRGTipoGerenteProyectoId
              : [
                  this.view.state.currentProaFormValues.proaRRHH
                    .PRGTipoGerenteProyectoId,
                ];
          }
        }
        break;
      case Enums.ProaBasicFields.TotalPersonasNecesarias:
        value = this.view.state.currentProaFormValues?.proaRRHH
          ?.PRGTotalPersonasnecesarias;
        break;
      case Enums.ProaBasicFields.ObjetivoEstrategico:
        {
          let _strategicLine = this.view.state?.currentApplicationMasters?.strategicLines?.find(
            (x: any) =>
              x.Id ===
              this.view.state.currentProaFormValues?.currentBudget
                ?.tituloLineaEstrategica
          );
          if (_strategicLine) {
            let interventionLines = this.view.state?.currentApplicationMasters?.interventionLines.find(
              (x: any) => x.Id == _strategicLine.PRGCodigoLineaIntervencionId
            );
            value =
              this.view.state?.currentApplicationMasters?.gaps?.find(
                (x: any) =>
                  x.Id == interventionLines.OCTAVIAGapLineaIntervencionId
              )?.Title ?? "";
          }
        }
        break;
      case Enums.ProaBasicFields.Planificacion:
        value =
          this.view.state.currentProaFormValues?.datosBasicos
            ?.PlanificacionAprobada ?? false;
        break;
      case Enums.ProaBasicFields.OtrosImplementadores:
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PRGOtrosImplementadores;
        //shouldReplaceHtmlTags = true;
        break;
      case Enums.ProaBasicFields.OtrosRolesImplementadores:
        value = this.view.state.currentProaFormValues?.aditionalSteps
          ?.PRGOtrosRolesImplementadores;
        //shouldReplaceHtmlTags = true;
        break;
    }
    return shouldReplaceHtmlTags
      ? value?.replace(/<div class="[A-Za-z0-9]*">/gi, "").replace("</div>", "")
      : value;
  }
  private getBasicField(fieldName: string) {
    if (Utilities.isNullEmptyObject(fieldName)) {
      throw new Error("The field name is required");
    }

    let data: IAEAColumnDefinition = this.view.state.basicDataColumnDefinition.get(
      fieldName
    );

    if (Utilities.isNullObject(data)) {
      console.error(`Field not found with name ${fieldName}`);
      throw new Error("Field not found");
    }

    let template: any = {
      description: data.OCTAVIATooltip,
      id: `${data.Id}_ProaSummary`,
      placeholder: !Utilities.isNullEmptyObject(data.OCTAVIATooltip)
        ? data.OCTAVIATooltip
        : (data as any).OCTAVIATooltip || "",
      readOnly:
        this._viewMode ||
        (data.OCTAVIASoloVista != null ? data.OCTAVIASoloVista : false),
      required: data.OCTAVIARequerido != null ? data.OCTAVIARequerido : false,
      title: !Utilities.isNullEmptyObject(data.NombreColumna)
        ? data.NombreColumna
        : (data as any).NombreColumna0 || "",
      requiredErrorMessage: "campo obligatorio",
      onValueChanged: (value: any) => this.onFieldChange(data.Title, value),
      multiple: data.OCTAVIAMultiple != null ? data.OCTAVIAMultiple : false,
      fieldType: data.TipoCampoProyecta,
      defaultValue: this.getValue(data.Title),
      value: this.getValue(data.Title),
    };

    if (Enums.FieldTypes.Textarea === data.TipoCampoProyecta) {
      template.maxLength = 2500;
    }

    if (Enums.FieldTypes.Select === data.TipoCampoProyecta) {
      template.items = this.getItems(fieldName);
    }

    if (Enums.ProaBasicFields.TotalPersonasNecesarias === fieldName) {
      template.format = Constants.GeneralFormats.NUMBER_FORMAT;
    }

    return template;
  }
  private formatDate(dateStr: any) {
    if (Utilities.isNullObject(dateStr)) {
      return String.Empty;
    }
    try {
      return new Date(dateStr);
    } catch (error) {
      console.log("error");
      console.error("formatDate");
      console.error(error);
    }
  }
  private getItems(fieldName: string): ISelectItem[] {
    if (!Utilities.isNullObject(this.view.state.currentApplicationMasters)) {
      switch (fieldName) {
        case Enums.ProaBasicFields.Etiquetas:
          return this.convertToSelectItems(
            this.view.state.currentApplicationMasters.tags
          );
        case Enums.ProaBasicFields.BeneficiaryCollective:
          return this.convertToSelectItems(
            this.view.state.currentApplicationMasters.collective
          );
        case Enums.ProaBasicFields.TipoAdministrador:
        case Enums.ProaBasicFields.TipoGerenteProyecto:
          return this.convertToSelectItems(
            this.view.state.currentApplicationMasters.typeRRHH
          );
      }
    }
    return [];
  }
  private convertToSelectItems(
    items: any[],
    keyField: string = "Id",
    labelField: string = "Title",
    preffix: string = "",
    code: string = ""
  ) {
    return items.map((item) => {
      return {
        id: String.IsNullOrWhiteSpace(preffix)
          ? item[keyField]
          : preffix + item[keyField],
        label: item[labelField],
        code: String.IsNullOrWhiteSpace(code) ? "" : item[code],
      };
    });
  }
  private onFieldChange(field: string, value: any) {
    let datosbasicos = this.view.state.currentProaFormValues ?? {};

    if (this.fieldInBasicData(field)) {
      datosbasicos.datosBasicos[field] = value;
    } else if (this.fieldInRRHH(field)) {
      if (Utilities.isNullObject(datosbasicos.proaRRHH)) {
        datosbasicos.proaRRHH = {};
      }
      datosbasicos.proaRRHH[field] = value;
    } else {
      if (Utilities.isNullObject(datosbasicos.aditionalSteps)) {
        datosbasicos.aditionalSteps = {};
      }
      datosbasicos.aditionalSteps[field] = value;
    }

    this.view.state.setCurrentProaFormValues(datosbasicos);
  }
  private fieldInBasicData(field: string) {
    return [
      Enums.ProaBasicFields.Etiquetas,
      Enums.ProaBasicFields.FechaFin,
      Enums.ProaBasicFields.FechaInicio,
      Enums.ProaBasicFields.Planificacion,
    ].includes(field as Enums.ProaBasicFields);
  }
  private fieldInRRHH(field: string) {
    return [
      Enums.ProaBasicFields.TotalPersonasNecesarias,
      Enums.ProaBasicFields.TipoGerenteProyecto,
      Enums.ProaBasicFields.DedicacionGerente,
      Enums.ProaBasicFields.IdentificacionGerente,
      Enums.ProaBasicFields.TipoAdministrador,
      Enums.ProaBasicFields.DedicacionAdministrador,
      Enums.ProaBasicFields.IdentificacionAdministrador,
    ].includes(field as Enums.ProaBasicFields);
  }
  private mappCurrentProaToProaEntity() {
    const proaEntity = {
      Title: this.view.state.currentProaFormValues.currentBudget.Title,
      PPresPresupuestoId: parseInt(
        this.view.state.currentProaFormValues.currentBudget.Id
      ),
      PlanificacionAprobada:
        this.view.state.currentProaFormValues.datosBasicos[
          Enums.ProaBasicFields.Planificacion
        ] ?? false,
      OCTAVIAFechaInicio: this.view.state.currentProaFormValues.datosBasicos
        .OCTAVIAFechaInicio,
      OCTAVIAFechaFinalizacion: this.view.state.currentProaFormValues
        .datosBasicos.OCTAVIAFechaFinalizacion,
      OCTAVIAEtiquetasId: {
        results: this.view.state.currentProaFormValues.datosBasicos
          .OCTAVIAEtiquetasId,
      },
    } as ICmdBasicDataProjectProa;

    if (
      !Utilities.isNullObject(
        this.view.state.currentProaFormValues.datosBasicos?.Id
      )
    ) {
      proaEntity.Id = this.view.state.currentProaFormValues.datosBasicos.Id;
    }
    return proaEntity;
  }
  private mappCurrentProaStepsToEntity() {
    const proaEntity = {
      PRGLocalizacion: this.view.state.currentProaFormValues.aditionalSteps
        ?.PRGLocalizacion,
      PRGMetodologia: this.view.state.currentProaFormValues.aditionalSteps
        ?.PRGMetodologia,
      PRGParticipacion: this.view.state.currentProaFormValues.aditionalSteps
        ?.PRGParticipacion,
      PRGProblematica: this.view.state.currentProaFormValues.aditionalSteps
        ?.PRGProblematica,
      PRGResumenProyecto: this.view.state.currentProaFormValues.aditionalSteps
        ?.PRGResumenProyecto,
      PRGRolAeA: this.view.state.currentProaFormValues.aditionalSteps
        ?.PRGRolAeA,
      PRGRolImplementadores: this.view.state.currentProaFormValues
        .aditionalSteps?.PRGRolImplementadores,
      PRGDescripcionBeneficiarios: this.view.state.currentProaFormValues
        .aditionalSteps?.PRGDescripcionBeneficiarios,
      PFRRBeneficiariosId: {
        results: this.view.state.currentProaFormValues.aditionalSteps
          ?.PFRRBeneficiariosId,
      },
      PRGOtrosRolesImplementadores: this.view.state.currentProaFormValues
        .aditionalSteps?.PRGOtrosRolesImplementadores,
      PRGOtrosImplementadores: this.view.state.currentProaFormValues
        .aditionalSteps?.PRGOtrosImplementadores,
    } as IProaDetailImpl;

    if (
      !Utilities.isNullObject(
        this.view.state.currentProaFormValues.aditionalSteps?.Id
      )
    ) {
      proaEntity.Id = this.view.state.currentProaFormValues.aditionalSteps.Id;
    }

    return proaEntity;
  }
  private mappCurrentProaRrhhToProaEntity() {
    const proaEntity = {
      PPresPresupuestoId: parseInt(
        this.view.state.currentProaFormValues.currentBudget.Id
      ),
      PRGDedicacionAdministrador: this.view.state.currentProaFormValues.proaRRHH
        .PRGDedicacionAdministrador,
      PRGDedicacionGerente: this.view.state.currentProaFormValues.proaRRHH
        .PRGDedicacionGerente,
      PRGIdentificacionAdministrador0: this.view.state.currentProaFormValues
        .proaRRHH.PRGIdentificacionAdministrador0,
      PRGIdentificacionGerente0: this.view.state.currentProaFormValues.proaRRHH
        .PRGIdentificacionGerente0,
      PRGTotalPersonasnecesarias: this.view.state.currentProaFormValues.proaRRHH
        .PRGTotalPersonasnecesarias,
      PRGTipoAdministradorId: this.view.state.currentProaFormValues.proaRRHH
        .PRGTipoAdministradorId
        ? this.view.state.currentProaFormValues.proaRRHH
            .PRGTipoAdministradorId[0]
        : null,
      PRGTipoGerenteProyectoId: this.view.state.currentProaFormValues.proaRRHH
        .PRGTipoGerenteProyectoId
        ? this.view.state.currentProaFormValues.proaRRHH
            .PRGTipoGerenteProyectoId[0]
        : null,
    } as ICmdBasicDataProjectProaRRHH;

    if (this.view.state.currentProaFormValues.proaRRHH?.Id) {
      proaEntity.Id = this.view.state.currentProaFormValues.proaRRHH.Id;
    }
    return proaEntity;
  }
  //#endregion

  //#region Get Methods
  public get projectCodeTextField() {
    return this.getBasicField(Enums.ProaBasicFields.PrCode);
  }

  public get countryField() {
    return this.getBasicField(Enums.ProaBasicFields.Country);
  }

  public get titleField() {
    return this.getBasicField(Enums.ProaBasicFields.NombreProyecto);
  }

  public get regionCountryField() {
    return this.getBasicField(Enums.ProaBasicFields.Region);
  }

  public get tagsListField() {
    return this.getBasicField(Enums.ProaBasicFields.Etiquetas);
  }
  public get lineIntervencionField() {
    return this.getBasicField(Enums.ProaBasicFields.LineaEstrategica);
  }

  public get strategicLineField() {
    return this.getBasicField(Enums.ProaBasicFields.IndicadorLineaEstrategica);
  }

  public get planificationField() {
    return this.getBasicField(Enums.ProaBasicFields.Planificacion);
  }

  public get beginDateField() {
    const dateFieldProps = {
      ...this.getBasicField(Enums.ProaBasicFields.FechaInicio),
    };
    dateFieldProps.onValueChanged = (value: any) => {
      this.onFieldChange(Enums.ProaBasicFields.FechaInicio, value);
      this.view.state.setBeginDate(value);
    };
    return dateFieldProps;
  }

  public get endDateField() {
    let dateFieldProps = this.getBasicField(Enums.ProaBasicFields.FechaFin);
    dateFieldProps.minDate = this.view.state.beginDate ?? new Date();
    dateFieldProps.onValueChanged = (value: any) => {
      this.onFieldChange(Enums.ProaBasicFields.FechaFin, value);
      this.view.state.setEndDate(value);
    };
    return dateFieldProps;
  }

  public getTotalPermissions(){
    const TEAM_CENTRAL = this.params[Enums.Params.proyectaCentralTeam]
    const ADMIN_GROUP = this.params[Enums.Params.proyectaAdminModule]
    
    let userGroupsName: any[] = this?.currentUser?.userGroups?.map((x: any) => x.displayName)
    
    return (userGroupsName?.includes(TEAM_CENTRAL) || userGroupsName?.includes(ADMIN_GROUP))
  }

  public get projectSummaryField() {
    return this.getBasicField(Enums.ProaBasicFields.ProjectSummary);
  }

  public get problemsAndJustificationField() {
    return this.getBasicField(Enums.ProaBasicFields.ProblemsAndJustification);
  }

  public get methodologyField() {
    return this.getBasicField(Enums.ProaBasicFields.Methodology);
  }

  public get aeaRolField() {
    return this.getBasicField(Enums.ProaBasicFields.AEARol);
  }

  public get implementersRolField() {
    return this.getBasicField(Enums.ProaBasicFields.ImplementersRol);
  }

  public get aeaParticipatesInEjecutionField() {
    return this.getBasicField(Enums.ProaBasicFields.AEAParticipatesInEjecution);
  }

  public get getLocalPartners() {
    return this.view.state.localPertners;
  }

  public get commonSelectPropsField() {
    return this.getBasicField(Enums.ProaBasicFields.CompletarLocaciones);
  }

  public get getBeneficiaryDescriptionField() {
    return this.getBasicField(Enums.ProaBasicFields.BeneficiaryDescription);
  }

  public get getBeneficiaryCollectiveField() {
    return this.getBasicField(Enums.ProaBasicFields.BeneficiaryCollective);
  }

  public get getLocationsList() {
    return this.view.state.section4Locations;
  }

  public get getTotalPersonasNecesariasField() {
    return this.getBasicField(Enums.ProaBasicFields.TotalPersonasNecesarias);
  }

  public get getTipoGerenteProyectoField() {
    return this.getBasicField(Enums.ProaBasicFields.TipoGerenteProyecto);
  }

  public get getDedicacionGerenteField() {
    return this.getBasicField(Enums.ProaBasicFields.DedicacionGerente);
  }

  public get getIdentificacionGerenteField() {
    return this.getBasicField(Enums.ProaBasicFields.IdentificacionGerente);
  }

  public get getTipoAdministradorField() {
    return this.getBasicField(Enums.ProaBasicFields.TipoAdministrador);
  }

  public get getDedicacionAdministradoreField() {
    return this.getBasicField(Enums.ProaBasicFields.DedicacionAdministrador);
  }

  public get getIdentificacionAdministradorField() {
    return this.getBasicField(
      Enums.ProaBasicFields.IdentificacionAdministrador
    );
  }

  public get isViewMode() {
    return this._viewMode;
  }

  public get strategicObjetiveField() {
    return this.getBasicField(Enums.ProaBasicFields.ObjetivoEstrategico);
  }
  public get getOtherImplementers() {
    return this.getBasicField(Enums.ProaBasicFields.OtrosImplementadores);
  }
  public get getOtherImplementersRol() {
    return this.getBasicField(Enums.ProaBasicFields.OtrosRolesImplementadores);
  }
  //#endregion
}
